import React, { FC } from 'react'
import { Area } from 'models/project'
import { Source, Layer } from 'react-map-gl'
import { geometryToGeoJson } from 'utils/geometryToGeoJson'

type CompareAreaProps = {
  area?: Area
  centro?: boolean
}

export const CompareArea: FC<CompareAreaProps> = ({ area, centro }) => {
  if (!area) {
    return null
  }

  if (centro === true) {

    return (<Source key="compared-area-pin" type="geojson" data={area.centroid}>
      <Layer
        key="compared-area-point-C"
        id="compared-area-point-C"
        type="circle"
        paint={{
          'circle-color': "#FFE800",
          'circle-radius': 6
        }}
      />
      <Layer
        key="compared-area-point"
        id="compared-area-point"
        type="circle"
        paint={{
          'circle-color': area.color,
          'circle-radius': 4
        }}
      />
    </Source>
    )
  } else {
    return (
      <Source id="compared-area" type="geojson" data={geometryToGeoJson(area.geometry)}>
        <Layer
          key="compared-area-fill"
          id="compared-area-fill"
          type="fill"
          paint={{
            'fill-color': area.color,
            'fill-opacity': 0.1,
          }}
        />
        <Layer
          key="compared-area-line"
          id="compared-area-line"
          type="line"
          paint={{
            'line-width': 2,
            'line-color': area.color,
            'line-dasharray': [4, 2],
          }}
        />
      </Source>
    )
  }


}

CompareArea.displayName = 'CompareArea'
